import axios from 'axios';
import Qs from 'qs';
import router from './router'
// import Vue from 'vue'
import {
	Message
} from 'element-ui';

// Vue.prototype.$url = 'http://xingchenapi.ran-wei.net/'//正式地址
// Vue.prototype.$url = 'http://knowledgeapi.fztek.net'//正式地址
// Vue.prototype.$url = 'http://sunlifeapi.ran-wei.net'
// // import router from '../router/index';
// 创建axios实例
const service = axios.create({
	baseURL: 'http://api.shisw.net',
	// baseURL: 'http://duanpianapi.ran-wei.net',
	//baseURL:'https://localhost:44331',
	timeout: 50000 // 请求超时时间                                   
})
// 添加request拦截器 
service.interceptors.request.use(config => {
	return config
}, error => {
	Promise.reject(error)
})
// 添加respone拦截器
service.interceptors.response.use(

	response => {
		//如果存在token并且token无法使用，则重新登录
		if (response.data.Code == 1001 && localStorage.getItem('AccessToken')) {
			localStorage.removeItem('AccessToken');
			localStorage.removeItem('RefreshToken');
			localStorage.removeItem('username');
			Message({
				message: response.data.Message,
				type: 'error'
			});
			router.push("/Login")
		}
		if(response.data.Code==1){
			Message({
				message: response.data.Message,
				type: 'error'
			});
			return
		}
		return response;
	},
	error => {

		// Message.error(error.message);
		return Promise.reject(error.response)
	}
)

export function get(url, params = {}) {
	// params.t = new Date().getTime(); //get方法加一个时间参数,解决ie下可能缓存问题.
	params.token = params.token || params.Token || localStorage.getItem('AccessToken');
	return service({
		url: url,
		method: 'get',
		headers: {
			'content-type': 'application/x-www-form-urlencoded',
		},
		params
	})
}


//封装post请求
export function post(url, data = {}, headers, joint = true) {
	//默认配置 
	data.Token = data.token || data.Token || localStorage.getItem('AccessToken');
	let sendObject = {
		url: url,
		method: 'post',
		headers: headers || {
			// 'Content-Type': 'application/json;charset=UTF-8'
			'Content-type': 'application/x-www-form-urlencoded',
			// 'Content-type': 'application/problem+json; charset=utf-8'

		},
		data: joint ? Qs.stringify(data) : data //是否使用拼接数据方式传输，如果 joint==false data就为json格式
	};

	return service(sendObject)
}



//不要忘记export
export {
	service
}
